import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/shared')) {
      document.title = 'Your friend shared an email summary with you via SumMail AI';
    } else {
      document.title = 'SumMail AI';
    }
  }, [pathname]);

  return null; 
};

export default TitleManager;

